import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../editable-cell'

interface PantonesProps {}

const Pantones: FC<PantonesProps> = () => {
    const ctx = useContext(EditableCellCtx)
    return (
        <Form.Item name={'pantones'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} />
        </Form.Item>
    )
}

export default Pantones
